<template>
  <div class="parent">
    <div class="box">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div class="bar">
          <span class="stat-item">{{ `已添加商品种类(${totalCategories})` }}</span>
          <el-divider direction="vertical"></el-divider>
          <span class="stat-item">{{ `商品件数(${totalQty})` }}</span>
          <el-divider direction="vertical"></el-divider>
          <span class="stat-item">{{ `促销(${promotionQty})` }}</span>
          <el-divider direction="vertical"></el-divider>
          <span class="stat-item">{{ `降价(${reducePriceQty})` }}</span>
        </div>
        <div class="search-box">
          <Search @searchKeywordChange="searchKeywordChange" @clearInput="searchKeywordChange"></Search>
        </div>
      </div>

      <!-- 排序和筛选区域 -->
      <div class="filter-section relative">
        <div class="sort-box">
          <div class="sort-item" :class="{ active: !params.sort }" @click="clearSort">
            <span>默认排序</span>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            class="sort-item"
            @click="sortClick('code')"
            :class="{ active: params.sort && params.sort.includes('code') }"
          >
            <span>编码</span>
            <SortIcon
              code-name="code"
              ref="sortIconcode"
              :current-code="currentCode"
              @changeSort="e => changeSort(e, 'code')"
            ></SortIcon>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            class="sort-item"
            @click="sortClick('qty')"
            :class="{ active: params.sort && params.sort.includes('qty') }"
          >
            <span>库存</span>
            <SortIcon
              code-name="qty"
              ref="sortIconqty"
              :current-code="currentCode"
              @changeSort="e => changeSort(e, 'qty')"
            ></SortIcon>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            class="sort-item"
            @click="sortClick('price')"
            :class="{ active: params.sort && params.sort.includes('price') }"
          >
            <span>价格</span>
            <SortIcon
              code-name="price"
              ref="sortIconprice"
              :current-code="currentCode"
              @changeSort="e => changeSort(e, 'price')"
            ></SortIcon>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            :class="{
              relative: true,
              'sort-item': true,
              'cursor-pointer': true,
              'filter-active': categorieShow,
              active: params.category
            }"
            @click="openCategorieSelectPopup"
          >
            <div class="chooseTxt" v-if="params.category">
              <span>{{ params.category }}</span>
            </div>
            <span v-else>分类</span>
            <div class="trigger-icon">
              <i class="el-icon-arrow-down"></i>
            </div>
            <CategorieSelect ref="categorieRef" @change="checkChange"></CategorieSelect>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            :class="{
              'sort-item': true,
              'cursor-pointer': true,
              'filter-active': brandPopupShow,
              active: brandValue && brandValue.length > 0
            }"
            @click="openSelectBrandPopup"
          >
            <span v-if="brandValue && brandValue.length === 0">品牌</span>
            <div class="chooseTxt" v-else>
              <span>{{ brandValue.join(",") }}</span>
            </div>
            <div class="trigger-icon">
              <i class="el-icon-arrow-down"></i>
            </div>
            <BrandPanel ref="brandRef" @change="selectBrand"></BrandPanel>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div
            :class="{
              'sort-item': true,
              'cursor-pointer': true,
              'filter-active': placePopupShow,
              active: productionPlaceValue && productionPlaceValue.length > 0
            }"
            @click="openPlaceOriginPopup"
          >
            <span v-if="productionPlaceValue && productionPlaceValue.length === 0">产地</span>
            <div class="chooseTxt" v-else>
              <span>{{ productionPlaceValue.join(",") }}</span>
            </div>
            <div class="trigger-icon">
              <i class="el-icon-arrow-down"></i>
            </div>
            <PlaceOrigin ref="placeOriginRef" @change="selectPlace"></PlaceOrigin>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="sort-item checkbox-item" :class="{ active: params.isPromotion !== 0 }">
            <el-checkbox :true-label="1" :false-label="0" v-model="params.isPromotion" @change="paramsChange"
              >促销</el-checkbox
            >
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="sort-item checkbox-item" :class="{ active: params.hasStock }">
            <el-checkbox v-model="params.hasStock" @change="paramsChange">有货</el-checkbox>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="sort-item checkbox-item" :class="{ active: params.isNormalBuy }">
            <el-checkbox v-model="params.isNormalBuy" @change="paramsChange">常购</el-checkbox>
          </div>
        </div>
      </div>

      <!-- 购物车列表 -->
      <div
        class="cart-content"
        v-newloading="{
          visible: loading,
          text: '加载中...'
        }"
      >
        <product-list
          ref="productListRef"
          :list="shoppingCartsList"
          :select-all="selectAll"
          @refresh="getCarts"
          @cancelSelectAll="cancelSelectAll"
          @changeSelect="selectRows"
        ></product-list>

        <!-- 分页组件 -->
        <div class="pagination-container" v-if="shoppingCartsList && shoppingCartsList.length > 0">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>

        <!-- 空状态 -->
        <div v-if="shoppingCartsList && shoppingCartsList.length === 0" class="empty-state">
          <i class="el-icon-shopping-cart-1"></i>
          <p>购物车为空</p>
          <el-button type="primary" @click="$router.push('/new-products')">去购物</el-button>
        </div>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div class="cart-footer" v-if="shoppingCartsList && shoppingCartsList.length > 0">
      <div class="footer-left">
        <el-checkbox v-model="selectAll" @change="changeAllSelectTion">全选</el-checkbox>
        <el-divider direction="vertical"></el-divider>
        <span class="selected-info"
          >已选{{ selectAll ? totalCategories : selectList.length }}种，{{
            selectAll ? totalQty : countQTY
          }}件商品</span
        >
        <el-divider direction="vertical"></el-divider>
        <span class="batch-action">批量操作</span>
        <el-button size="small" style="margin-left:12px" type="danger" plain @click="deleteShoppingCart"
          >删除</el-button
        >
        <el-button size="small" type="danger" plain @click="deleteAllData">清空购物车</el-button>
      </div>
      <div class="footer-right">
        <div class="price-info">
          <div class="price-row">
            <span
              >已选{{ selectAll ? totalCategories : selectList.length }}种，{{
                selectAll ? totalQty : countQTY
              }}件商品</span
            >
            <span class="total-price"
              >合计：<em>￥{{ selectAll ? totalAmount : selectedGoodsSumPrice }}</em></span
            >
          </div>
          <div class="price-row" v-if="discountedMoney > 0 && !selectAll">
            <span>
              原价：
              <span class="original-price">￥{{ originalPrice }}</span>
            </span>
            <span class="discount">已优惠：￥{{ discountedMoney }}</span>
          </div>
        </div>
        <button class="checkout-btn" @click="placeOrder">
          <i class="el-icon-shopping-bag-1"></i>
          去下单(F7)
        </button>
      </div>
    </div>

    <PlaceOrderType ref="placeOrderType" />
  </div>
</template>

<script>
import Search from "../../components/common/Search.vue";
import ProductList from "../../components/shoppingCartList/Index.vue";
import SortIcon from "../../components/common/Sort.vue";
import PlaceOrderType from "@/components/PlaceOrderType";
import { getShoppingCartList, deleteShoppingCart } from "@/api/shoppingCart/index.js";
import { getCategoriesTree, getDictsByType } from "@/api/base";
import BrandPanel from "../../components/common/BrandPanel.vue";
import CategorieSelect from "../../components/common/CategorieSelect.vue";
import PlaceOrigin from "../../components/common/PlaceOrigin.vue";

export default {
  components: {
    Search,
    ProductList,
    SortIcon,
    PlaceOrderType,
    BrandPanel,
    CategorieSelect,
    PlaceOrigin
  },
  computed: {
    countQTY() {
      return this.selectList.reduce((acc, current) => {
        return Number(acc) + Number(current.qty);
      }, 0);
    },
    selectedGoodsSumPrice() {
      let sum = 0;
      this.selectList.map(item => {
        sum += Number(item.qty) * Number(item.goods.price);
      });
      return isNaN(sum) ? "议价" : this.showAmount(sum);
    },
    // 原价
    originalPrice() {
      let sum = 0;
      this.selectList.map(item => {
        sum += Number(item.goods.goodsNum) * Number(item.goods.originalPrice);
      });
      return this.showAmount(sum);
    },
    // 已优惠
    discountedMoney() {
      return this.showAmount(Number(this.originalPrice) - Number(this.selectedGoodsSumPrice));
    }
  },
  data() {
    return {
      loading: true,
      selectList: [],
      allSelectList: [],
      selectAll: false,
      shoppingCartsList: [],
      totalQty: 0,
      totalCategories: 0,
      totalAmount: 0,
      reducePriceQty: 0,
      promotionQty: 0,
      params: {
        isNormalBuy: false,
        isReducePrice: false,
        isPromotion: 0,
        keyword: "",
        sort: "",
        productionPlace: "",
        brand: "",
        category: ""
      },
      treeData: [],
      brandList: [],
      productionPlace: [],
      brandValue: [],
      productionPlaceValue: [],
      placePopupShow: false,
      categorieShow: false,
      brandPopupShow: false,
      currentCode: "",
      // 分页相关数据
      total: 0,
      currentPage: 1,
      pageSize: 10
    };
  },
  methods: {
    sortClick(code) {
      this.currentCode = code;
      const refName = `sortIcon${code}`;
      this.$refs[refName].sortFun();
    },
    crearParams() {
      this.params = {
        isNormalBuy: false,
        isReducePrice: false,
        isPromotion: 0,
        keyword: "",
        sort: "",
        productionPlace: "",
        brand: "",
        category: ""
      };
      this.currentCode = "";
      this.brandValue = [];
      this.productionPlaceValue = [];
    },
    resetPageSize() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.total = 0;
    },
    //清空购物车
    deleteAllData() {
      this.$confirm("此操作将删除所有商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteShoppingCart({ all: true });
            this.$message({
              type: "success",
              message: "清空成功!"
            });
            this.paramsChange();
            this.$bus.$emit("shoppingCartRefresh");
          } catch (error) {
            this.$message({
              type: "error",
              message: "清空失败," + error.message
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消清空"
          });
        });
    },
    //批量删除
    deleteShoppingCart() {
      if (this.selectAll) {
        this.deleteAllData();
        return;
      }
      this.$confirm("此操作将删除所选商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const ids = this.allSelectList.map(e => e.id);
          try {
            await deleteShoppingCart({ ids });
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.$bus.$emit("shoppingCartRefresh");
            this.getCarts();
          } catch (error) {
            this.$message({
              type: "error",
              message: "删除失败," + error.message
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    placeOrder() {
      // 过滤出无货和已失效商品和购买参数失效的商品
      const selectList = this.selectList.filter(
        item => !item.outOfStock && !item.lostEffectiveness && !item.goodsSpecification.show.includes("购买规格已失效")
      );
      if (!selectList.length) {
        this.$message.warning("请勾选要下单的商品！");
        return;
      }

      this.$refs.placeOrderType.show({
        allCarts: this.selectAll,
        type: "shoppingCart",
        data: window.tool.deepClone(selectList)
      });
    },
    handleKeydown(e) {
      if (e.key === "F7") {
        e.preventDefault();
        e.stopPropagation();
        this.placeOrder();
      }
    },
    //取消全选
    cancelSelectAll() {
      this.selectAll = false;
    },
    changeAllSelectTion() {
      if (this.selectAll && this.allSelectList.length === this.shoppingCartsList.length) {
        return;
      }
      if (this.$refs.productListRef) {
        this.$refs.productListRef.selectAllFun();
      }
    },
    selectRows(list) {
      this.allSelectList = list.map(e => e);
      this.selectList = list.filter(item => {
        return !item.lostEffectiveness && !item.goodsSpecification.show.includes("失效");
      });
    },
    includeChineseCharacters(str) {
      return /^[\u4e00-\u9fa5]+$/.test(String(str));
    },
    /**
     * 金额显示2位小数
     */
    showAmount(amount) {
      if (this.includeChineseCharacters(amount)) {
        return amount;
      }
      if (amount === undefined || amount === null) {
        return Number(0).toFixed(2);
      }
      const num = Number(amount).toFixed(2);
      if (num !== "NaN" && num !== "Infinity") {
        return Number(amount).toFixed(2);
      }
      return amount;
    },
    clearSort() {
      this.params.sort = "";
      this.currentCode = "";
      this.getCarts(true);
    },
    selectPlace(list) {
      this.productionPlaceValue = list;
      this.changeProductPlace(list);
      this.placePopupShow = false;
    },
    openPlaceOriginPopup() {
      this.placePopupShow = !this.placePopupShow;
      if (!this.placePopupShow) {
        this.$refs.placeOriginRef.cancel();
      } else {
        this.$refs.placeOriginRef.open(this.productionPlace, this.productionPlaceValue);
      }
    },
    openCategorieSelectPopup() {
      this.categorieShow = !this.categorieShow;
      this.$refs.categorieRef.open(this.categorieShow, this.treeData, this.params.category);
    },
    selectBrand(list) {
      this.brandValue = list;
      this.changeBrand(list);
      this.brandPopupShow = false;
    },
    openSelectBrandPopup() {
      this.brandPopupShow = !this.brandPopupShow;
      if (!this.brandPopupShow) {
        this.$refs.brandRef.cancel();
      } else {
        this.$refs.brandRef.open(this.brandList, this.brandValue);
      }
    },
    //params其他参数设置
    setParamsOthersKey() {
      this.params.noCategory = !!!this.params.category;
    },
    checkChange(val) {
      if (val) {
        this.params.category = val;
      } else {
        this.params.category = "";
      }
      this.setParamsOthersKey();
      this.resetPageSize();
      this.getCarts(true);
    },
    changeProductPlace(v) {
      if (v && v.length > 0) {
        this.params.productionPlace = v.join();
      } else {
        this.params.productionPlace = "";
      }
      this.resetPageSize();
      this.getCarts(true);
    },
    paramsChange() {
      this.resetPageSize();
      this.getCarts(true);
    },
    changeBrand(v) {
      if (v && v.length > 0) {
        this.params.brand = v.join();
      } else {
        this.params.brand = "";
      }
      this.resetPageSize();
      this.getCarts(true);
    },
    changeSort(sort, code) {
      this.currentCode = code;
      if (sort) {
        this.params.sort = `${code}-${sort}`;
      } else {
        this.params.sort = "";
      }
      this.resetPageSize();
      this.getCarts(true);
    },
    // 处理每页数量变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getCarts(true);
    },
    // 处理当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCarts(true);
    },
    async getCarts(flag) {
      this.loading = true;
      try {
        // 在请求参数中添加分页信息
        const requestParams = {
          ...this.params,
          page: this.currentPage,
          pageSize: this.pageSize
        };

        let res = await getShoppingCartList(requestParams);
        if (!res || !res.rows || res.rows.length === 0) {
          this.shoppingCartsList = [];
          this.totalQty = 0;
          this.totalCategories = 0;
          this.totalAmount = 0;
          this.reducePriceQty = 0;
          this.promotionQty = 0;
          // 设置分页总条数
          this.total = 0;
        } else {
          this.shoppingCartsList = res.rows.map(e => {
            if (!e.coupons) {
              e.coupons = [];
            }
            // 比加入时
            if (Number(e.priceGap) > 0) {
              e.goods.priceGapName = `比加入时涨价${this.showAmount(e.priceGap)}元`;
            }
            if (Number(e.priceGap) < 0) {
              e.goods.priceGapName = `比加入时降价${this.showAmount(Math.abs(Number(e.priceGap)))}元`;
            }
            if (Number(e.goods.minBuyQty) && Number(e.goods.uQty)) {
              e.goods.minQty = tool.getOrderQuantity(Number(e.goods.minBuyQty), Number(e.goods.uQty));
            } else {
              e.goods.minQty = 1;
            }
            e.lostEffectiveness = e.goods.id < 1;
            return e;
          });
          this.totalQty = res.totalQty || 0;
          this.totalCategories = res.totalCategories || 0;
          this.totalAmount = res.totalAmount || 0;
          this.reducePriceQty = res.reducePriceQty || 0;
          this.promotionQty = res.promotionQty || 0;
          // 设置分页总条数
          this.total = res.totalSize || 0;
        }
      } catch (error) {
        this.$message.error(error.message || "获取失败");
        this.shoppingCartsList = [];
        this.totalQty = 0;
      }
      if (flag) {
        this.$bus.$emit("scrollTop");
      }
      this.loading = false;
    },
    searchKeywordChange(v) {
      this.params.keyword = v;
      this.currentPage = 1; // 搜索时重置到第一页
      this.getCarts(true);
    },
    getCategoryList() {
      getCategoriesTree()
        .then(res => {
          if (res) {
            const treeData = {
              id: "all",
              name: "全部分类",
              disabled: true,
              children: [...res]
            };
            this.treeData = [treeData];
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //获取品牌
    async getProductBrand() {
      let res = await getDictsByType({ type: "brand" });
      this.brandList = res;
    },
    //获取产地
    async getProductionPlace() {
      let res = await getDictsByType({ type: "productionPlace" });
      this.productionPlace = res;
    }
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
    this.getCarts();
  },
  created() {
    // this.$bus.$emit("scrollTop");
    this.$bus.$on("shoppingCartRefresh", () => {
      this.getCarts();
    });
    this.getProductBrand();
    this.getCategoryList();
    this.getProductionPlace();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  }
};
</script>

<style lang="scss" scoped>
.parent {
  // background: #f5f7fa;
  // min-height: 100vh;
  // padding: 16px;
}

.box {
  margin: 0 auto;
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
}

// 搜索栏样式
.search-bar {
  background: #fff;
  border-radius: 2px;
  padding: 12px 8px;
  margin-bottom: 12px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .bar {
    display: flex;
    align-items: center;
    gap: 20px;

    .stat-item {
      font-size: 14px;
      font-weight: 600;
      color: var(--color-primary);
      background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
      padding: 6px 12px;
      border-radius: 2px;
    }
  }

  .search-box {
    width: 400px;
  }
}

// 筛选区域样式
.filter-section {
  background: white;
  border-radius: 2px;
  padding: 8px 12px;
  margin-bottom: 12px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .sort-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    .el-divider--vertical {
      height: 16px;
      margin: 0 4px;
    }

    .sort-item {
      padding: 8px 12px;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #606266;
      border: 1px solid transparent;

      &:hover {
        background: #f5f7fa;
        color: var(--color-primary);
      }

      &.active {
        background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
        color: var(--color-primary);
        // border-color: var(--color-primary);
      }

      &.filter-active {
        background: color-mix(in srgb, var(--color-light80) 30%, transparent) !important;
        // border-color: var(--color-primary);
      }

      .chooseTxt {
        max-width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          color: var(--color-primary);
          font-weight: 500;
        }
      }

      .trigger-icon {
        transition: transform 0.3s;
        font-size: 12px;
        color: #c0c4cc;
      }

      &.filter-active .trigger-icon {
        transform: rotate(180deg);
        color: var(--color-primary);
      }

      &.checkbox-item {
        border: none;
        background: transparent;

        &:hover {
          background: #f5f7fa;
        }

        &.active {
          background: #ecf5ff;

          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: var(--color-primary);
            border-color: var(--color-primary);
          }

          ::v-deep .el-checkbox__label {
            color: var(--color-primary);
            font-weight: 500;
          }
        }
      }
    }
  }
}

// 购物车内容区域
.cart-content {
  flex: 1;
  background: white;
  // border-radius: 2px;
  overflow: hidden;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

// 分页样式
.pagination-container {
  padding: 20px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #f0f0f0;

  ::v-deep .el-pagination {
    .el-pager li,
    .btn-prev,
    .btn-next {
      border-radius: 2px;
      margin: 0 4px;
      font-weight: 500;
    }

    .el-pager li.active {
      background-color: var(--color-primary);
      color: white;
    }

    .el-pagination__total {
      font-size: 14px;
      color: #666;
    }

    .el-pagination__jump {
      font-size: 14px;
      color: #666;
    }
  }
}

// 空状态样式
.empty-state {
  padding: 80px 20px;
  text-align: center;
  color: #909399;

  i {
    font-size: 64px;
    margin-bottom: 16px;
    color: #c0c4cc;
  }

  p {
    font-size: 16px;
    margin-bottom: 24px;
  }
}

// 底部结算栏样式
.cart-footer {
  position: fixed;
  z-index: 999;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 12px;
  background: white;
  border-top: 1px solid #e4e7ed;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  overflow: hidden;
  // box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);

  .footer-left {
    display: flex;
    align-items: center;
    gap: 16px;

    .selected-info {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .batch-action {
      font-size: 14px;
      color: #999;
    }
  }

  .footer-right {
    display: flex;
    align-items: center;
    gap: 24px;

    .price-info {
      text-align: right;

      .price-row {
        margin-bottom: 4px;

        &:last-child {
          margin-bottom: 0;
        }

        .total-price {
          margin-left: 16px;
          font-size: 16px;
          color: #333;

          em {
            font-style: normal;
            color: #f56c6c;
            font-weight: 700;
            font-size: 20px;
          }
        }

        .original-price {
          text-decoration: line-through;
          color: #999;
          margin-right: 16px;
        }

        .discount {
          color: #67c23a;
          font-size: 14px;
        }
      }
    }

    .checkout-btn {
      background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
      border: none;
      border-radius: 25px;
      padding: 12px 32px;
      color: white;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 4px 12px rgba(238, 90, 36, 0.3);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(238, 90, 36, 0.4);
      }

      &:active {
        transform: translateY(0);
      }

      i {
        font-size: 18px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .search-bar {
    flex-direction: column;
    gap: 16px;

    .bar {
      width: 100%;
      justify-content: center;
    }

    .search-box {
      width: 100%;
    }
  }

  .filter-section {
    .sort-box {
      gap: 4px;

      .sort-item {
        padding: 6px 8px;
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 768px) {
  .parent {
    padding: 8px;
  }

  .cart-footer {
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px;

    .footer-left,
    .footer-right {
      width: 100%;
      justify-content: center;
    }

    .footer-right {
      flex-direction: column;
      gap: 12px;
    }
  }

  .filter-section {
    .sort-box {
      justify-content: center;
    }
  }

  .pagination-container {
    padding: 15px 10px;

    ::v-deep .el-pagination {
      .el-pagination__sizes,
      .el-pagination__jump {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
// 全局样式调整
.none-border .el-input .el-input__inner {
  border: none;
  background: transparent;
}

// 购物车表格美化
.cart-content {
  .el-table {
    // border-radius: 8px;
    overflow: hidden;

    th {
      background: #f8f9fa;
      color: #333;
      font-weight: 600;
    }

    .el-table__row:hover {
      background: #f5f7fa;
    }
  }
}
</style>
